import visual from 'assets/images/community/visual.png';

export const krQna = {
  title: `커뮤니티`,
  subTitle: `Community`,
  subject: `Q&A`,
  subjectDesc: `Q&A`,
  visual,
};

export const enQna = {
  title: `커뮤니티`,
  subTitle: `Community`,
  subject: `Q&A`,
  subjectDesc: `Q&A`,
  visual,
};

export const krQnaForm = {
  title: `커뮤니티`,
  subTitle: `Community`,
  subject: `Q&A`,
  subjectDesc: `Q&A`,
  visual,
  question: [
    {
      type: 'input',
      inputType: 'text',
      required: true,
      label: '성함',
      name: 'userName',
      placeholder: `성함을 입력해 주세요`,
    },
    { type: 'input', inputType: 'tel', required: true, label: '연락처', name: 'tel', placeholder: `-빼고 숫자만 입력` },
    {
      type: 'input',
      inputType: 'text',
      required: true,
      label: '이메일',
      name: 'email',
      placeholder: `example@example.com`,
    },
    {
      type: 'input',
      inputType: 'password',
      label: '비밀번호',
      name: 'password',
      placeholder: `비밀번호를 입력해 주세요`,
    },
    {
      type: 'input',
      inputType: 'password',
      label: '비밀번호 확인',
      name: 'passwordCheck',
      placeholder: `비밀번호를 입력해 주세요`,
    },
    {
      type: 'input',
      inputType: 'text',
      required: true,
      label: '문의 제목',
      name: 'subject',
      placeholder: `문의 제목을 입력해 주세요`,
    },
    { type: 'checkbox', label: '비밀글로 문의하기' },
    {
      type: 'textarea',
      required: true,
      label: '문의 내용',
      name: 'content',
      placeholder: `문의하실 내용을 적어주세요.`,
    },
  ],
  uploadFile: `파일 첨부`,
  uploadInputLabel: `파일 선택`,
  uploadDesc: `선택된 파일 없음`,
  agree: `개인정보처리방침에 동의합니다.`,
  agreeView: `보기`,
  submitBtn: `문의하기`,
  cancelBtn: `취소`,
  errorMessages: {
    requiredPolicy: '개인 정보 보호 정책에 동의해주세요.',
    required: '필수 입력항목 입니다.',
    saveDone: '문의가 등록되었습니다.',
    invalidEmail: '잘못된 이메일 주소 입니다.',
    invalidPhone: '숫자만 입력해주세요.'
  }
};

export const enQnaForm = {
  title: `커뮤니티_EN`,
  subTitle: `Community`,
  subject: `QNA_EN`,
  subjectDesc: `QNA`,
  visual,
  question: [
    {
      type: 'input',
      inputType: 'text',
      required: true,
      label: '성함',
      name: 'userName',
      placeholder: `성함을 입력해 주세요`,
    },
    { type: 'input', inputType: 'tel', required: true, label: '연락처', name: 'tel', placeholder: `-빼고 숫자만 입력` },
    { type: 'input', inputType: 'text', label: '이메일', name: 'email', placeholder: `example@example.com` },
    {
      type: 'input',
      inputType: 'password',
      label: '비밀번호',
      name: 'password',
      placeholder: `비밀번호를 입력해 주세요`,
    },
    {
      type: 'input',
      inputType: 'password',
      label: '비밀번호 확인',
      name: 'passwordCheck',
      placeholder: `비밀번호를 입력해 주세요`,
    },
    {
      type: 'input',
      inputType: 'text',
      required: true,
      label: '문의 제목',
      name: 'subject',
      placeholder: `문의 제목을 입력해 주세요`,
    },
    { type: 'checkbox', label: '비밀글로 문의하기' },
    {
      type: 'textarea',
      label: '문의 내용',
      required: true,
      name: 'content',
      placeholder: `문의하실 내용을 적어주세요.`,
    },
  ],
  uploadFile: `파일 첨부`,
  uploadInputLabel: `파일 선택`,
  uploadDesc: `선택된 파일 없음`,
  agree: `개인정보처리방침에 동의합니다.`,
  agreeView: `보기`,
  submitBtn: `문의하기`,
  cancelBtn: `취소`,
  errorMessages: {
    requiredPolicy: '개인 정보 보호 정책에 동의해주세요.',
    required: '필수 입력항목 입니다.',
    saveDone: '문의가 등록되었습니다.',
    invalidEmail: '잘못된 이메일 주소 입니다.',
    invalidPhone: '숫자만 입력해주세요.'
  }
};

export const krQnaPwd = {
  text: `해당 글은 비밀글입니다.\n비밀번호를 입력해 주세요.`,
  placeholder: `비밀번호 입력`,
  cancel: `돌아가기`,
  submit: `확인`,
  wrongPassword: '비밀번호가 일치하지 않습니다.'
};
export const enQnaPwd = {
  text: `해당 글은 비밀글입니다.\n비밀번호를 입력해 주세요.`,
  placeholder: `비밀번호 입력`,
  cancel: `돌아가기`,
  submit: `확인`,
  wrongPassword: '비밀번호가 일치하지 않습니다.'
};
